const $c317b466c945ac58$var$winning = [
    [
        0,
        1,
        2
    ],
    [
        3,
        4,
        5
    ],
    [
        6,
        7,
        8
    ],
    [
        0,
        3,
        6
    ],
    [
        1,
        4,
        7
    ],
    [
        2,
        5,
        8
    ],
    [
        0,
        4,
        8
    ],
    [
        2,
        4,
        6
    ]
];
var $c317b466c945ac58$export$2e2bcd8739ae039 = $c317b466c945ac58$var$winning;


// console.log(winning);
// dom element
const $efd3ba4ec2608b1d$var$headingEl = document.querySelector(".heading");
const $efd3ba4ec2608b1d$var$currentPlayerEl = document.querySelector(".current_player");
const $efd3ba4ec2608b1d$var$boxesEl = document.querySelectorAll(".box");
const $efd3ba4ec2608b1d$var$resetBtnEl = document.querySelector(".reset-button");
const $efd3ba4ec2608b1d$var$players = [
    "o",
    "x"
];
let $efd3ba4ec2608b1d$var$currentPlayer;
let $efd3ba4ec2608b1d$var$gameGrid;
// fxn
function $efd3ba4ec2608b1d$var$randomPLayer() {
    const newPlayer = Math.floor(Math.random() * 2);
    $efd3ba4ec2608b1d$var$currentPlayer = $efd3ba4ec2608b1d$var$players[newPlayer];
}
function $efd3ba4ec2608b1d$var$swapPlayer() {
    const newPlayer = $efd3ba4ec2608b1d$var$currentPlayer === $efd3ba4ec2608b1d$var$players[0] ? $efd3ba4ec2608b1d$var$players[1] : $efd3ba4ec2608b1d$var$players[0];
    $efd3ba4ec2608b1d$var$currentPlayer = newPlayer;
}
function $efd3ba4ec2608b1d$var$startGame() {
    $efd3ba4ec2608b1d$var$gameGrid = new Array(9).fill("");
    $efd3ba4ec2608b1d$var$resetBtnEl.classList.remove("active");
    $efd3ba4ec2608b1d$var$randomPLayer();
    $efd3ba4ec2608b1d$var$currentPlayerEl.texContent = $efd3ba4ec2608b1d$var$currentPlayer;
}
$efd3ba4ec2608b1d$var$startGame();
function $efd3ba4ec2608b1d$var$checkWinner() {
    (0, $c317b466c945ac58$export$2e2bcd8739ae039).forEach((chance)=>{
        const [c1, c2, c3] = chance;
        // console.log(c1,c2,c3);
        if ($efd3ba4ec2608b1d$var$gameGrid[c1] && $efd3ba4ec2608b1d$var$gameGrid[c2] && $efd3ba4ec2608b1d$var$gameGrid[c3] && $efd3ba4ec2608b1d$var$gameGrid[c1] === $efd3ba4ec2608b1d$var$gameGrid[c2] && $efd3ba4ec2608b1d$var$gameGrid[c2] === $efd3ba4ec2608b1d$var$gameGrid[c3]) {
            $efd3ba4ec2608b1d$var$boxesEl.forEach((box)=>box.style.pointerEvents = "none");
            // show new game
            $efd3ba4ec2608b1d$var$resetBtnEl.classList.add("active");
            // add green class
            $efd3ba4ec2608b1d$var$boxesEl[c1].classList.add("green");
            $efd3ba4ec2608b1d$var$boxesEl[c2].classList.add("green");
            $efd3ba4ec2608b1d$var$boxesEl[c3].classList.add("green");
            $efd3ba4ec2608b1d$var$headingEl.textContent = `${$efd3ba4ec2608b1d$var$gameGrid[c1]} won!`;
            $efd3ba4ec2608b1d$var$currentPlayerEl.textContent = `${$efd3ba4ec2608b1d$var$gameGrid[c1]}won!`;
        //   console.log("win of game is :", currentPlayer);
        }
        const x = $efd3ba4ec2608b1d$var$gameGrid.every((el)=>el !== "");
        if (x && !$efd3ba4ec2608b1d$var$headingEl.textContent.includes("won")) {
            $efd3ba4ec2608b1d$var$headingEl.textContent = "Game is Draw";
            $efd3ba4ec2608b1d$var$resetBtnEl.classList.add("active");
        }
    });
//   console.log(winning);
}
function $efd3ba4ec2608b1d$var$handleclick(index) {
    // if only gamegrid is empty
    if ($efd3ba4ec2608b1d$var$gameGrid[index] === "") {
        // update player in dom and remove hover hand
        $efd3ba4ec2608b1d$var$boxesEl[index].textContent = $efd3ba4ec2608b1d$var$currentPlayer;
        $efd3ba4ec2608b1d$var$boxesEl[index].style.pointerEvents = "none";
        // update gamegrid
        // currentPlayerEl.textContent = currentPlayer;
        $efd3ba4ec2608b1d$var$gameGrid[index] = $efd3ba4ec2608b1d$var$currentPlayer;
        $efd3ba4ec2608b1d$var$checkWinner();
        $efd3ba4ec2608b1d$var$currentPlayerEl.textContent = $efd3ba4ec2608b1d$var$currentPlayer;
        $efd3ba4ec2608b1d$var$swapPlayer();
    }
// console.log(index);
}
$efd3ba4ec2608b1d$var$boxesEl.forEach((box, index)=>{
    box.addEventListener("click", ()=>{
        $efd3ba4ec2608b1d$var$handleclick(index);
    });
});
$efd3ba4ec2608b1d$var$resetBtnEl.addEventListener("click", ()=>{
    $efd3ba4ec2608b1d$var$startGame();
    $efd3ba4ec2608b1d$var$headingEl.textContent = "NOughts & Crosses";
    $efd3ba4ec2608b1d$var$boxesEl.forEach((box)=>{
        box.classList.remove("green");
        box.textContent = "";
        box.style.pointerEvents = "auto";
    });
});


//# sourceMappingURL=index.24f150ce.js.map
